(function () {
  'use strict';

  function initBundlePicker(root) {
    if (!root) return;

    var productId  = root.dataset.productId;
    var bundleSize = parseInt(root.dataset.bundleSize, 10) || 3;

    var selections   = new Array(bundleSize).fill('');
    var openSlot     = -1;

    var slots          = root.querySelectorAll('.mf-bp__slot');
    var pips           = root.querySelectorAll('.mf-bp__pip');
    var remainingLabel = document.getElementById('mf-bp-remaining-' + productId);
    var combinedInput  = root.querySelector('[data-bundle-combined]');

    /* ── Reposition picker before buy button ── */
    function repositionPicker() {
      var formComponent = document.querySelector('product-form-component');
      if (!formComponent) return;
      var target = formComponent;
      while (target && target.parentElement) {
        if (target.parentElement.classList.contains('group-block-content')) {
          target.parentElement.insertBefore(root, target);
          return;
        }
        target = target.parentElement;
      }
    }
    setTimeout(repositionPicker, 100);
    setTimeout(repositionPicker, 500);

    /* ── Create validation modal ── */
    var modal = document.createElement('div');
    modal.id = 'mf-bp-modal';
    modal.style.cssText = [
      'display:none;position:fixed;top:0;left:0;width:100%;height:100%;',
      'background:rgba(0,0,0,0.5);z-index:99999;',
      'align-items:center;justify-content:center;'
    ].join('');
    modal.innerHTML = [
      '<div style="background:#fff;border-radius:8px;padding:2rem;max-width:480px;width:90%;margin:0 auto;color:#111;">',
      '<h2 style="font-size:1.5rem;font-weight:700;margin:0 0 1rem;color:#111;">Selections Required</h2>',
      '<p style="margin:0 0 0.5rem;font-size:1rem;color:#111;">Please make your choice for:</p>',
      '<p id="mf-bp-modal-missing" style="font-weight:700;margin:0 0 1.5rem;font-size:1rem;color:#111;"></p>',
      '<button id="mf-bp-modal-ok" style="width:100%;padding:1rem;background:#111;color:#fff;border:none;',
      'border-radius:4px;font-size:1rem;font-weight:600;cursor:pointer;">OK</button>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    document.getElementById('mf-bp-modal-ok').addEventListener('click', function () {
      modal.style.display = 'none';
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.style.display = 'none';
    });

    function showValidationModal(missingSlots) {
      var names = missingSlots.map(function (i) { return 'Selection ' + (i + 1); });
      document.getElementById('mf-bp-modal-missing').textContent = names.join(', ');
      modal.style.display = 'flex';
    }

    function validate() {
      var missing = [];
      selections.forEach(function (sel, i) {
        if (!sel) missing.push(i);
      });
      return missing;
    }

    /* ── Intercept add to cart buttons ── */
    function interceptAddToCart() {
      var addBtns = document.querySelectorAll(
        '[data-testid="standalone-add-to-cart"], ' +
        'button[name="add"], ' +
        '.add-to-cart-button, ' +
        '[id*="BuyButtons"][id*="add-to-cart"]'
      );
      addBtns.forEach(function (btn) {
        if (btn.dataset.mfIntercepted) return;
        btn.dataset.mfIntercepted = 'true';
        btn.addEventListener('click', function (e) {
          var missing = validate();
          if (missing.length > 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            missing.forEach(function (i) { slots[i].classList.add('is-invalid'); });
            showValidationModal(missing);
            return false;
          }
          injectPropertiesIntoForm();
        }, true);
      });
    }

    function injectPropertiesIntoForm() {
      var properties = {};
      selections.forEach(function (sel, i) {
        if (sel) properties['Selection ' + (i + 1)] = sel;
      });
      window.__mfBundleProperties = properties;
    }

    if (!window.__mfFetchPatched) {
      window.__mfFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function (url, options) {
        if (
          typeof url === 'string' &&
          url.includes('/cart/add') &&
          window.__mfBundleProperties &&
          Object.keys(window.__mfBundleProperties).length > 0
        ) {
          try {
            var opts = options || {};
            var body = opts.body;
            var parsed;
            if (typeof body === 'string') {
              parsed = JSON.parse(body);
            } else if (body instanceof FormData) {
              parsed = {};
              body.forEach(function (val, key) { parsed[key] = val; });
            } else {
              parsed = {};
            }
            parsed.properties = parsed.properties || {};
            var props = window.__mfBundleProperties;
            Object.keys(props).forEach(function (k) {
              parsed.properties[k] = props[k];
            });
            opts.body = JSON.stringify(parsed);
            opts.headers = opts.headers || {};
            opts.headers['Content-Type'] = 'application/json';
            window.__mfBundleProperties = null;
            return origFetch(url, opts);
          } catch (err) {
            window.__mfBundleProperties = null;
          }
        }
        return origFetch.apply(this, arguments);
      };
    }

    function openPanel(index) {
      slots.forEach(function (s, i) {
        var panel   = s.querySelector('.mf-bp__panel');
        var trigger = s.querySelector('.mf-bp__trigger');
        var isThis  = i === index;
        s.classList.toggle('is-open', isThis);
        if (panel) panel.hidden = !isThis;
        if (trigger) trigger.setAttribute('aria-expanded', isThis ? 'true' : 'false');
      });
      openSlot = index;
      if (index >= 0 && index < bundleSize) {
        var inp = slots[index] && slots[index].querySelector('.mf-bp__search-input');
        if (inp) setTimeout(function () { inp.focus(); }, 40);
      }
    }

    function closeAll() {
      slots.forEach(function (s) {
        s.classList.remove('is-open');
        var panel   = s.querySelector('.mf-bp__panel');
        var trigger = s.querySelector('.mf-bp__trigger');
        if (panel) panel.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      openSlot = -1;
    }

    function selectItem(slotIndex, value, name, inspired, imgSrc) {
      selections[slotIndex] = value;
      var slot      = slots[slotIndex];
      var thumb     = slot.querySelector('[data-thumb]');
      var thumbNum  = slot.querySelector('.mf-bp__thumb-num');
      var titleEl   = slot.querySelector('[data-trigger-title]');
      var subEl     = slot.querySelector('[data-trigger-sub]');
      var clearBtn  = slot.querySelector('[data-clear]');
      var hiddenInp = root.querySelector('[data-bundle-value="' + slotIndex + '"]');

      if (imgSrc) {
        thumb.innerHTML = '<img src="' + imgSrc + '" alt="' + name + '" width="52" height="52" style="width:100%;height:100%;object-fit:cover;display:block;">';
      } else {
        if (thumbNum) thumbNum.style.display = 'none';
      }
      if (titleEl) titleEl.textContent = name;
      if (subEl) subEl.textContent = inspired || '';
      if (clearBtn) clearBtn.hidden = false;
      if (hiddenInp) hiddenInp.value = value;

      slot.classList.add('is-filled');
      slot.classList.remove('is-invalid');
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) {
        li.classList.toggle('is-selected', li.dataset.value === value);
        li.setAttribute('aria-selected', li.dataset.value === value ? 'true' : 'false');
      });

      updateProgress();
      updateCombined();
      closeAll();
    }

    function clearSlot(slotIndex) {
      selections[slotIndex] = '';
      var slot      = slots[slotIndex];
      var thumb     = slot.querySelector('[data-thumb]');
      var thumbNum  = slot.querySelector('.mf-bp__thumb-num');
      var titleEl   = slot.querySelector('[data-trigger-title]');
      var subEl     = slot.querySelector('[data-trigger-sub]');
      var clearBtn  = slot.querySelector('[data-clear]');
      var hiddenInp = root.querySelector('[data-bundle-value="' + slotIndex + '"]');

      if (thumbNum) {
        thumb.innerHTML = '';
        thumb.appendChild(thumbNum);
        thumbNum.style.display = '';
      }
      if (titleEl) titleEl.textContent = 'Selection ' + (slotIndex + 1);
      if (subEl) subEl.textContent = 'Please select an option';
      if (clearBtn) clearBtn.hidden = true;
      if (hiddenInp) hiddenInp.value = '';

      slot.classList.remove('is-filled', 'is-invalid');
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) {
        li.classList.remove('is-selected');
        li.setAttribute('aria-selected', 'false');
      });

      updateProgress();
      updateCombined();
      closeAll();
    }

    function updateProgress() {
      var filled = 0;
      pips.forEach(function (pip, i) {
        var isFilled = !!selections[i];
        pip.classList.toggle('filled', isFilled);
        if (isFilled) filled++;
      });
      var remaining = bundleSize - filled;
      var counter = root.querySelector('.mf-bp__counter');
      if (filled === bundleSize) {
        if (counter) counter.innerHTML = '&#10003; Great — all ' + bundleSize + ' selected!';
      } else {
        if (counter) counter.innerHTML = 'Select <strong>' + remaining + '</strong> more fragrance' + (remaining === 1 ? '' : 's');
      }
      if (remainingLabel) remainingLabel.textContent = remaining;
    }

    function updateCombined() {
      if (!combinedInput) return;
      var allFilled = selections.every(function (s) { return s !== ''; });
      combinedInput.value = allFilled ? selections.join(' | ') : '';
    }

    function filterItems(searchInput, slotIndex) {
      var query   = searchInput.value.toLowerCase().trim();
      var slot    = slots[slotIndex];
      var items   = slot.querySelectorAll('.mf-bp__item');
      var empty   = slot.querySelector('.mf-bp__empty');
      var visible = 0;
      items.forEach(function (item) {
        var matches = !query || (item.dataset.search || '').includes(query);
        item.hidden = !matches;
        if (matches) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    }

    function moveActive(slotIndex, direction) {
      var slot    = slots[slotIndex];
      var visible = Array.from(slot.querySelectorAll('.mf-bp__item:not([hidden])'));
      if (!visible.length) return;
      var current = slot.querySelector('.mf-bp__item.is-active');
      var idx     = current ? visible.indexOf(current) : -1;
      idx += direction;
      if (idx < 0) idx = visible.length - 1;
      if (idx >= visible.length) idx = 0;
      slot.querySelectorAll('.mf-bp__item').forEach(function (li) { li.classList.remove('is-active'); });
      visible[idx].classList.add('is-active');
      visible[idx].scrollIntoView({ block: 'nearest' });
    }

    slots.forEach(function (slot, i) {
      var trigger = slot.querySelector('.mf-bp__trigger');
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-clear]')) return;
          openSlot === i ? closeAll() : openPanel(i);
        });
      }

      var clearBtn = slot.querySelector('[data-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          clearSlot(i);
        });
      }

      var searchInp = slot.querySelector('.mf-bp__search-input');
      if (searchInp) {
        searchInp.addEventListener('input', function () { filterItems(this, i); });
        searchInp.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(i, 1); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(i, -1); }
          else if (e.key === 'Enter') {
            e.preventDefault();
            var active = slot.querySelector('.mf-bp__item.is-active:not([hidden])');
            if (active) active.click();
          } else if (e.key === 'Escape') { closeAll(); }
        });
      }

      slot.querySelectorAll('.mf-bp__item').forEach(function (item) {
        item.addEventListener('click', function () {
          selectItem(i, item.dataset.value, item.dataset.name, item.dataset.inspired, item.dataset.img);
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    interceptAddToCart();
    setTimeout(interceptAddToCart, 500);
    setTimeout(interceptAddToCart, 1500);
  }

  function init() {
    document.querySelectorAll('.mf-bundle-picker').forEach(function (root) {
      initBundlePicker(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();